{
  "breaches": {
    "count": "Twoje dane konta zostały ujawnione w {count} naruszeniach danych.",
    "discovered": "To naruszenie zostało po raz pierwszy wykryte {date}.",
    "empty": {
      "text": "Nie znaleźliśmy żadnych wycieków danych dla Twojego konta.",
      "title": "Nie znaleziono wycieków danych"
    },
    "high": "Wysoki",
    "medium": "Średni",
    "title": "Naruszenia",
    "watchlist": {
      "button": "Dodaj email",
      "text": "Monitorowane adresy e-mail",
      "title": "Lista obserwowanych"
    }
  },
  "cards": {
    "breaches": {
      "text": "Tutaj możesz sprawdzić, w ilu naruszeniach danych brało udział Twoje konto. Naruszenia danych są kategoryzowane według stopnia zagrożenia oraz rodzaju ujawnionych informacji. Jeśli Twoje dane zostały ujawnione w wyniku naruszenia, upewnij się, że zmienisz swoje hasło.",
      "title": "Czy Twoje dane zostały ujawnione?"
    },
    "overview": {
      "text": "Hej {name}! Jak zapewne wiesz, ataki phishingowe stają się coraz bardziej zaawansowane i niebezpieczne. Centrum to miejsce, w którym możesz śledzić swoje postępy i dowiedzieć się jeszcze więcej o cyberatakach zagrażających Twojej firmie. Zdobądź osiągnięcia w obszarze cyberbezpieczeństwa i stań się ekspertem w tej dziedzinie mgnieniu oka.",
      "title": "Witamy w Centrum szkoleniowym!"
    },
    "quiz": {
      "text": "Rozpocznij interaktywną podróż z quizem i sprawdź swoje umiejętności w rozróżnianiu prawdziwych i phishingowych e-maili. Quiz został zaprojektowany, aby przetestować Twoją wiedzę i zrozumienie zagrożeń, które istnieją w rzeczywistym świecie.",
      "title": "Sprawdź się w quizie!"
    },
    "simulations": {
      "text": "Na tej stronie możesz zobaczyć szczegóły symulacji otrzymanych od Moxso w ciągu ostatnich 90 dni. Rozumiejąc, jak są zaprojektowane e-maile phishingowe, będziesz w stanie je zidentyfikować i chronić się przed nimi.",
      "title": "Czy padłeś ofiarą phishingu?"
    },
    "videos": {
      "text": "Na tej stronie możesz oglądać filmy o zagrożeniach cybernetycznych i dowiedzieć się, jak chronić siebie i swoją firmę przed nimi. Filmy są dostępne w dowolnym czasie, więc możesz je oglądać wtedy, gdy Ci wygodnie.",
      "title": "Gotów? Zaczynamy!"
    }
  },
  "certificate": {
    "certificate_of_completion": "Certyfikat ukończenia",
    "certificate_unlocked": "Certyfikat dostępny",
    "share_on_linkedin": "Udostępnij na LinkedIn",
    "show_certificate": "Pokaż certyfikat",
    "text": "Ukończyłeś kurs? Pokaż swój certyfikat innym!"
  },
  "courses": {
    "all": "Wszystkie kursy",
    "completed": {
      "badge": "Ukończono",
      "button": "Ukończ kurs",
      "text": "Ukończyłeś kurs",
      "title": "Świetna robota!"
    },
    "content": {
      "breach": {
        "text": "Włącz wykrywanie naruszeń dla swojego konta",
        "title": "Skonfiguruj wykrywanie naruszeń"
      },
      "download": {
        "button": "Pobierz"
      },
      "introduction": {
        "contents": "Zawartość",
        "start": "Rozpocznij kurs",
        "text": "Wprowadzenie i przegląd kursu",
        "title": "Wprowadzenie"
      },
      "quiz": {
        "choose_answer": "Wybierz poprawną odpowiedź poniżej:",
        "correct": "Poprawne",
        "correct_answer": "{label}: {answer}",
        "correct_answer_label": "Poprawna odpowiedź",
        "next_question": "Następne pytanie",
        "oh_no": "O nie!",
        "question_of": "Pytanie {current} z {total}",
        "result": {
          "button": "Ukończ quiz",
          "text": "Odpowiedziałeś poprawnie na {correct} z {total} pytań.",
          "title": "Dobra robota!",
          "title_fail": "Jeszcze trochę!"
        },
        "text": "Sprawdź się w quizie",
        "title": "Quiz",
        "view_results": "Zobacz wynik",
        "well_done": "Świetna robota!",
        "your_answer": "{label}: {answer}",
        "your_answer_label": "Twoja odpowiedź"
      },
      "video": {
        "text": "Poznaj kluczowe pojęcia, oglądając ten film"
      }
    },
    "continue": "Kontynuuj",
    "featured": "Polecane kursy",
    "lessons": "{count} lekcji",
    "progress": {
      "button": "Kontynuuj",
      "text": "Ukończyłeś {pct}% tego kursu"
    },
    "skip_video": {
      "button": "Pomiń",
      "text": "Oglądałeś ten film wcześniej. Pominąć go?"
    },
    "start_over": "Zacznij od nowa",
    "title": "Kursy"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "Pytanie wygasło",
        "network": "Wystąpił błąd",
        "noResponse": "Serwer nie odpowiada",
        "streaming": {
          "manifest": "Wystąpił błąd podczas odtwarzania filmu",
          "platform": "Ten film nie jest obsługiwany na twoim urządzeniu",
          "unavailable": "Ten film jest niedostępny"
        },
        "unknown": "Wystąpił nieznany błąd"
      },
      "messages": {
        "auth_failed": "Nieprawidłowy adres e-mail",
        "csrf": "Odśwież stronę i spróbuj ponownie",
        "email_missing": "Brak adresu e-mail powiązanego z tym kontem",
        "file_not_found": "Nie znaleziono pliku",
        "general_exception": "Wystąpił błąd",
        "invalid_answer": "Nieprawidłowa odpowiedź",
        "invalid_course": "Nieprawidłowy kurs",
        "invalid_domain": "Niepoprawna domena",
        "invalid_email": "Nieprawidłowy adres e-mail",
        "invalid_grant": "Nie można skontaktować się z dostawcą",
        "invalid_locale": "Tłumaczenie nie znaleziono",
        "invalid_option": "Nieprawidłowa opcja",
        "invalid_permissions": "Nie masz uprawnień do korzystania z tej funkcji.",
        "invalid_point": "Nieprawidłowa pozycja",
        "invalid_provider": "Nieprawidłowy dostawca",
        "invalid_quiz": "Nieprawidłowy quiz",
        "invalid_token": "Twoja sesja wygasła",
        "invalid_video": "Nieprawidłowy plik wideo",
        "missing_code": "Spróbuj ponownie",
        "two_factor_code_expired": "Kod uwierzytelniania dwuskładnikowego wygasł",
        "two_factor_code_invalid": "Nieprawidłowy kod dwuetapowy",
        "unauthorized": "Nie masz uprawnień do korzystania z tej funkcji",
        "user_not_found": "Użytkownik nie istnieje"
      },
      "validations": {
        "messages": {
          "throttle": "Zbyt wiele prób logowania. Proszę spróbować ponownie później."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Saldo konta",
        "address_book_contacts": "Kontakty z książki adresowej",
        "age_groups": "Grupy wiekowe",
        "ages": "Wiek",
        "appointments": "Wizyty",
        "apps_installed_on_devices": "Aplikacje zainstalowane na urządzeniach",
        "astrological_signs": "Znaki astrologiczne",
        "audio_recordings": "Nagrania audio",
        "auth_tokens": "Tokeny uwierzytelniające",
        "avatars": "Awatary",
        "bank_account_numbers": "Numery rachunków bankowych",
        "beauty_ratings": "Oceny wyglądu",
        "biometric_data": "Dane biometryczne",
        "bios": "Bios",
        "browser_user_agent_details": "Informacje o przeglądarce",
        "browsing_histories": "Historia przeglądania",
        "buying_preferences": "Preferencje zakupowe",
        "car_ownership_statuses": "Statusy posiadania samochodu",
        "career_levels": "Poziomy kariery",
        "cellular_network_names": "Nazwy sieci komórkowych",
        "charitable_donations": "Darowizny na cele charytatywne",
        "chat_logs": "Historia czatu",
        "credit_card_cvv": "Kod CVV karty kredytowej",
        "credit_cards": "Karty kredytowe",
        "credit_status_information": "Informacje o zdolności kredytowej",
        "customer_feedback": "Opinie klientów",
        "customer_interactions": "Interakcje z klientami",
        "dates_of_birth": "Daty urodzenia",
        "deceased_date": "Data zgonu",
        "deceased_statuses": "Statusy zmarłych",
        "device_information": "Informacje o urządzeniu",
        "device_serial_numbers": "Numery seryjne urządzeń",
        "device_usage_tracking_data": "Informacje o użyciu urządzenia",
        "drinking_habits": "Nawyki picia",
        "driver_s_licenses": "Prawa jazdy",
        "drug_habits": "Nawyki dotyczące narkotyków",
        "eating_habits": "Nawyki żywieniowe",
        "education_levels": "Poziomy wykształcenia",
        "email_addresses": "Adresy e-mail",
        "email_messages": "Wiadomości e-mail",
        "employers": "Pracodawcy",
        "employment_statuses": "Statusy zatrudnienia",
        "encrypted_keys": "Zaszyfrowane klucze",
        "ethnicities": "Grupy etniczne",
        "family_members_names": "Imiona członków rodziny",
        "family_plans": "Plany rodzinne",
        "family_structure": "Struktura rodziny",
        "financial_investments": "Inwestycje finansowe",
        "financial_transactions": "Transakcje finansowe",
        "fitness_levels": "Poziomy sprawności",
        "genders": "Płeć",
        "geographic_locations": "Lokalizacje geograficzne",
        "government_issued_i_ds": "Identyfikatory rządowe",
        "health_insurance_information": "Informacje o ubezpieczeniu zdrowotnym",
        "historical_passwords": "Poprzednie hasła",
        "hiv_statuses": "Status zakażeń HIV",
        "home_loan_information": "Informacje o kredycie hipotecznym",
        "home_ownership_statuses": "Statusy własności domu",
        "homepage_ur_ls": "Adresy URL strony głównej",
        "imei_numbers": "Numery IMEI",
        "imsi_numbers": "Numery IMSI",
        "income_levels": "Poziomy dochodów",
        "instant_messenger_identities": "Konta komunikatorów",
        "ip_addresses": "Adresy IP",
        "job_applications": "Podania o pracę",
        "job_titles": "Stanowiska pracy",
        "licence_plates": "Tablice rejestracyjne",
        "living_costs": "Koszty utrzymania",
        "login_histories": "Historie logowania",
        "mac_addresses": "Adresy MAC",
        "marital_statuses": "Statusy cywilne",
        "mnemonic_phrases": "Frazy odzyskiwania",
        "mothers_maiden_names": "Nazwiska panieńskie matek",
        "names": "Nazwy",
        "nationalities": "Narodowości",
        "net_worths": "Wartości netto",
        "nicknames": "Pseudonimy",
        "occupations": "Stanowiska",
        "parenting_plans": "Plany rodzicielskie",
        "partial_credit_card_data": "Niepełne dane karty kredytowej",
        "partial_dates_of_birth": "Niepełne daty urodzenia",
        "passport_numbers": "Numery paszportów",
        "password_hints": "Wskazówki dotyczące hasła",
        "password_strengths": "Siła haseł",
        "passwords": "Hasła",
        "payment_histories": "Historie płatności",
        "payment_methods": "Metody płatności",
        "personal_descriptions": "O mnie",
        "personal_health_data": "Dane osobowe dotyczące zdrowia",
        "personal_interests": "Zainteresowania",
        "phone_numbers": "Numery telefonów",
        "photos": "Zdjęcia",
        "physical_addresses": "Adresy",
        "physical_attributes": "Cechy fizyczne",
        "pi_ns": "Kody PIN",
        "places_of_birth": "Miejsce urodzenia",
        "political_donations": "Dotacje polityczne",
        "political_views": "Poglądy polityczne",
        "private_messages": "Wiadomości prywatne",
        "professional_skills": "Umiejętności zawodowe",
        "profile_photos": "Zdjęcia profilowe",
        "purchases": "Zakupy",
        "purchasing_habits": "Nawyki zakupowe",
        "races": "Pochodzenia etniczne",
        "recovery_email_addresses": "Adresy e-mail do odzyskiwania",
        "relationship_statuses": "Statusy związku",
        "religions": "Wyznania",
        "reward_program_balances": "Salda programów lojalnościowych",
        "salutations": "Formy grzecznościowe",
        "school_grades_class_levels": "Oceny i klasy",
        "security_questions_and_answers": "Pytania zabezpieczające konto",
        "sexual_fetishes": "Fetysze seksualne",
        "sexual_orientations": "Orientacje seksualne",
        "smoking_habits": "Nawyki związane z paleniem",
        "sms_messages": "Wiadomości SMS",
        "social_connections": "Kontakty",
        "social_media_profiles": "Profile w mediach społecznościowych",
        "social_security_numbers": "Numery ubezpieczenia społecznego",
        "spoken_languages": "Języki",
        "spouses_names": "Imiona małżonków",
        "support_tickets": "Zgłoszenia do wsparcia technicznego",
        "survey_results": "Wyniki ankiety",
        "taxation_records": "Dokumenty podatkowe",
        "telecommunications_carrier": "Operator sieci",
        "time_zones": "Strefy czasowe",
        "travel_habits": "Nawyki podróżowania",
        "user_statuses": "Statusy użytkowników",
        "user_website_ur_ls": "Adresy URL witryn użytkownika",
        "usernames": "Nazwy użytkowników",
        "utility_bills": "Rachunki za media",
        "vehicle_details": "Dane pojazdu",
        "website_activity": "Aktywność na stronie",
        "work_habits": "Nawyki pracy",
        "years_of_professional_experience": "Lata doświadczenia zawodowego"
      }
    },
    "certificates": {
      "compliance": "Szkolenie z cyberbezpieczeństwa"
    },
    "courses": {
      "toc": {
        "breach-content": "Naruszenia danych",
        "file-content": "Zawartość pliku",
        "intro-content": "Wprowadzenie",
        "quiz-content": "Quiz",
        "text-content": "Tekst",
        "video-content": "Wideo"
      }
    },
    "locales": {
      "current": "Angielski",
      "da_DK": "Duński",
      "de_DE": "Niemiecki",
      "en_US": "Angielski",
      "es_ES": "Hiszpański",
      "fi_FI": "Fiński",
      "fr_FR": "Francuski",
      "nb_NO": "Norweski",
      "nl_NL": "Niderlandzki",
      "pl_PL": "Polski",
      "pt_PT": "Portugalski",
      "sv_SE": "Szwedzki"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "Witamy na Twojej spersonalizowanej platformie do nauki! Cieszymy się, że do nas dołączyłeś i czekamy z niecierpliwością, aby pomóc Ci w osiągnięciu Twoich celów edukacyjnych.",
              "title": "Witamy w Moxso"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "Jak działa Moxso",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "Zaczynajmy 🙌",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Ochrona danych",
          "options": {
            "high": "Zaznajomiony",
            "low": "Niezaznajomiony",
            "medium": "Nieco zaznajomiony"
          },
          "question": "Jak dobrze jesteś zaznajomiony z podstawowymi zasadami ochrony danych (np. RODO)?"
        },
        "device_security": {
          "category": "Zasady bezpieczeństwa urządzeń",
          "options": {
            "high": "Tak, zawsze",
            "low": "Nie, nigdy",
            "medium": "Czasami"
          },
          "question": "Czy regularnie aktualizujesz swoje urządzenia i używasz narzędzi zabezpieczających, takich jak VPN?"
        },
        "digital_threats": {
          "category": "Świadomość zagrożeń cyfrowych",
          "options": {
            "high": "Zaznajomiony",
            "low": "Niezaznajomiony",
            "medium": "Nieco zaznajomiony"
          },
          "question": "Jak dobrze znasz zagrożenia cyfrowe takie jak malware, phishing i ransomware?"
        },
        "hybrid_work": {
          "category": "Bezpieczeństwo pracy zdalnej",
          "options": {
            "high": "Pewny",
            "low": "Niepewny",
            "medium": "Średnio pewny"
          },
          "question": "Jak pewny siebie jesteś w zachowaniu bezpieczeństwa podczas pracy zdalnej (np. korzystając z publicznej sieci Wi-Fi)?"
        },
        "incidents_breaches": {
          "category": "Zgłaszanie incydentów",
          "options": {
            "high": "Tak",
            "low": "Nie",
            "medium": "Częściowo"
          },
          "question": "Czy znasz procedurę zgłaszania incydentu bezpieczeństwa lub naruszenia?"
        },
        "passwords_accounts": {
          "category": "Zarządzanie hasłami",
          "options": {
            "high": "Używam menedżera haseł",
            "low": "Używam tych samych haseł",
            "medium": "Tworzę unikalne, silne hasła"
          },
          "question": "Jak zarządzasz hasłami do kont służbowych?"
        },
        "phishing": {
          "category": "Identyfikacja phishingu",
          "options": {
            "high": "Pewny",
            "low": "Niepewny",
            "medium": "Średnio pewny"
          },
          "question": "Jak bardzo jesteś pewny swojej umiejętności rozpoznawania prób phishingu w e-mailach lub wiadomościach?"
        },
        "physical_security": {
          "category": "Praktyki dotyczące bezpieczeństwa stanowiska pracy",
          "options": {
            "high": "Zawsze",
            "low": "Rzadko",
            "medium": "Czasami"
          },
          "question": "Jak często zabezpieczasz swoje stanowisko pracy (np. zamykając komputer, przechowując poufne dokumenty)?"
        },
        "secure_browsing": {
          "category": "Nawyki bezpiecznego przeglądania internetu",
          "options": {
            "high": "Tak, zawsze",
            "low": "Nie, nigdy",
            "medium": "Czasami"
          },
          "question": "Czy unikasz korzystania z publicznego Wi-Fi lub klikania podejrzanych linków podczas przeglądania?"
        }
      },
      "steps": {
        "finished": "Zakończono",
        "introduction": "Wprowadzenie",
        "quiz": "Quiz"
      }
    },
    "partners": {
      "cancer": "Duńskie Towarzystwo Onkologiczne",
      "itf": "Forum IT"
    },
    "quiz": {
      "error": {
        "checksum": "Nieprawidłowa suma kontrolna",
        "option": "Nieprawidłowa odpowiedź"
      },
      "intro": {
        "button": "Rozpocznij quiz",
        "text": "Przejdziemy przez 5 e-maili w Twojej skrzynce odbiorczej Moxso. Niektóre z wiadomości mogą pochodzić od oszustów próbujących uzyskać dostęp do wrażliwych danych - musisz zdecydować, czy e-mail jest próbą phishingu, czy nie. Jesteś gotowy?",
        "title": "Gotowy do zgłoszenia?"
      },
      "multiple-choice": {
        "heading": "Znajdź błąd w tym e-mailu.",
        "text": "tekst pomocy przy pytaniach wielokrotnego wyboru"
      },
      "options": {
        "email": "Email",
        "false": "To NIE jest phishing",
        "help": {
          "email": "Nadawca NIE jest zaufany",
          "false": "E-mail NIE powinien być zgłaszany",
          "link": "Link NIE prowadzi do wiarygodnego miejsca docelowego",
          "not-phishing": "To nie jest phishing",
          "true": "E-mail powinien zostać zgłoszony"
        },
        "link": "Link",
        "not-phishing": "To NIE jest phishing",
        "true": "To JEST phishing"
      },
      "title": "Quiz",
      "true-false": {
        "heading": "Czy to jest e-mail phishingowy?",
        "text": "Określ, czy jest to wiadomość phishingowa, czy nie"
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "Ten kurs jest niedostępny. Opcjonalne kursy są zablokowane, ale obowiązkowe szkolenia są zawsze dostępne.",
          "title": "Osiągnięto limit kursów"
        },
        "quiz": {
          "description": "Osiągnięto limit szkoleniowy. Opcjonalne quizy są tymczasowo zablokowane.",
          "title": "Osiągnięto limit quizów"
        },
        "video": {
          "description": "Osiągnięto limit treningowy. Opcjonalne filmy są zablokowane, ale obowiązkowe szkolenia są zawsze dostępne.",
          "title": "Osiągnięto limit filmów"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "Ten kurs jest niedostępny. Opcjonalne kursy są zablokowane, ale obowiązkowe szkolenia są zawsze dostępne.",
        "title": "Osiągnięto limit kursów"
      },
      "quiz": {
        "description": "Osiągnięto limit szkoleniowy. Opcjonalne quizy są tymczasowo zablokowane.",
        "title": "Osiągnięto limit quizów"
      },
      "reset": "Reset w poniedziałek",
      "video": {
        "description": "Osiągnięto limit szkoleniowy. Opcjonalne filmy są zablokowane, ale obowiązkowe szkolenia są zawsze dostępne.",
        "limit_reached": "Limit osiągnięty",
        "title": "Osiągnięto limit filmów"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "„Zaawansowane to seria dla osób szczególnie zainteresowanych cyberbezpieczeństwem, które chcą zrozumieć podstawowe mechanizmy działania hakowania i obrony przed nim. Jeśli zależy Ci tylko na podstawowej wiedzy o cyberbezpieczeństwie, filmy z tej serii nie są konieczne. Jeżeli natomiast chcesz dowiedzieć się więcej o hakowaniu, cyberatakach i o tym, jak skutecznie zwiększyć swoje bezpieczeństwo w sieci, ta seria jest dla Ciebie.",
          "title": "Zaawansowane",
          "tooltip": "Zostań ekspertem od hakowania w mgnieniu oka"
        },
        "ai": {
          "text": "Seria AI zgłębia rolę sztucznej inteligencji w cyberbezpieczeństwie. AI pełni podwójną funkcję – jest kluczowym narzędziem dla specjalistów IT do wykrywania i zwalczania zagrożeń, ale też potężnym narzędziem w rękach hakerów. Seria ma na celu zwiększenie świadomości na temat phishingu generowanego przez AI oraz pokazanie, jak bezpiecznie korzystać ze sztucznej inteligencji, by ograniczać błędy i ryzyko cyberataków. Podkreśla, że choć AI wspiera zarówno obrońców, jak i atakujących, to Twoje zachowanie pozostaje kluczowe dla bezpieczeństwa.",
          "title": "AI i cyberbezpieczeństwo",
          "tooltip": "Poznaj złożoną rolę AI w cyberbezpieczeństwie"
        },
        "compliance": {
          "text": "Ta kategoria zawiera filmy na temat kluczowych ustaw, standardów bezpieczeństwa i certyfikacji, które mogą pomóc chronić Twoje miejsce pracy przed zagrożeniami cyfrowymi. Filmy dają wgląd w Dyrektywę NIS2 oraz Regulację DORA, między innymi, które zapewniają solidne środki cyberbezpieczeństwa i zgodność z międzynarodowymi standardami. Dowiesz się, jakie znaczenie mają te regulacje, jak osiągnąć zgodność oraz jakie wymagania stawiają organizacjom w zakresie bezpieczeństwa i zarządzania ryzykiem. Poznasz też, co te przepisy oznaczają dla Ciebie i dlaczego warto poświęcić im uwagę.",
          "title": "Certyfikacje i zgodność",
          "tooltip": "Zrozum znaczenie certyfikacji i zgodności"
        },
        "gdpr": {
          "text": "RODO to seria, która zgłębia zasady, wymagania i reguły określone w RODO. RODO zostało wprowadzone w 2018 roku i wszystkie firmy muszą teraz przestrzegać RODO, aby zapewnić integralność i ochronę przetwarzanych danych osobowych. Seria obejmuje najbardziej istotne obszary RODO, które należy znać, aby prawidłowo przetwarzać dane osobowe w codziennym życiu. Seria ta zawiera filmy skierowane do wszystkich, w tym pracowników sektora prywatnego.",
          "title": "RODO",
          "tooltip": "Dowiedz się o najważniejszych wymaganiach i zasadach RODO oraz jak możesz ich przestrzegać w codziennym życiu."
        },
        "hacking": {
          "text": "Życie hakera to seria, która opowiada o ludziach stojących za cyberatakami. Przyjrzymy się metodom, których hakerzy używają, by zachować anonimowość w sieci, oraz sposobom, w jakie zarabiają. Filmy wyjaśniają też różne typy hakerów i dlaczego ich śledzenie bywa trudne.",
          "title": "Życie hakera",
          "tooltip": "Poznaj ludzi stojących za cyberatakami."
        },
        "money_laundering": {
          "text": "Pranie pieniędzy to seria, która przybliża różne metody używane przez przestępców do prania pieniędzy. Filmy wyjaśnią różne metody używane przez przestępców do prania pieniędzy oraz jak wykrywać i zapobiegać praniu pieniędzy.",
          "title": "Pranie pieniędzy",
          "tooltip": "Poznaj różne metody używane przez przestępców do prania pieniędzy oraz jak wykrywać i zapobiegać praniu pieniędzy"
        },
        "phishing": {
          "text": "Phishing to seria, która przybliża najczęściej spotykany cyberatak na świecie. Ataki phishingowe mogą działać samodzielnie lub być sposobem na uruchomienie bardziej zaawansowanych cyberataków. Jako pracownik ponosisz dużą odpowiedzialność za unikanie takich zagrożeń, np. poprzez nieklikanie w podejrzane linki w e-mailach. Filmy w tej serii pokażą Ci, czym jest phishing, jak działają hakerzy i jak nie stać się ofiarą tego typu ataków.",
          "title": "Phishing",
          "tooltip": "Dowiedz się więcej o najczęściej spotykanych cyberatakach"
        },
        "physical_security": {
          "text": "Bezpieczeństwo fizyczne to seria, która podkreśla znaczenie dobrej ochrony w miejscu pracy i w domu. Cyberbezpieczeństwo to coś więcej niż tylko zabezpieczenie Twoich urządzeń, to również bezpieczeństwo *wokół* urządzeń. Wiele osób zna pracę zdalną, a my pomożemy sprawić, by była ona jak najbardziej bezpieczna. Dodatkowo, dzięki tej serii, zdobędziesz wiedzę na temat wszystkiego, od zarządzania odwiedzającymi po cyberbezpieczeństwo na urządzeniach mobilnych oraz ryzyko korzystania z publicznych sieci.",
          "title": "Bezpieczeństwo fizyczne",
          "tooltip": "Dowiedz się, dlaczego bezpieczeństwo fizyczne jest kluczowym elementem dobrej cyberbezpieczeństwa."
        },
        "tips_and_tricks": {
          "text": "Porady i wskazówki to seria, która pomoże Ci zwiększyć cyberbezpieczeństwo. Nauczysz się konkretnych, praktycznych sposobów na ochronę siebie w sieci, a tym samym wzmocnisz bezpieczeństwo w miejscu pracy. Filmy pokażą również, dlaczego warto pamiętać o radach dotyczących cyberbezpieczeństwa, które mogłeś otrzymać wcześniej.",
          "title": "Porady i wskazówki",
          "tooltip": "Dowiedz się, jak zwiększyć swoje bezpieczeństwo cyfrowe"
        },
        "types_of_hacking": {
          "text": "Rodzaje hackingu to seria, która wyjaśnia różne metody stosowane przez hakerów, gdy próbują Cię oszukać. Każdy odcinek przedstawia podstawowe cechy danej metody, pokazuje, co haker może dzięki niej osiągnąć oraz jakie konsekwencje może to mieć dla Ciebie, jeśli zostaniesz zaatakowany. Oglądając filmy z tej serii, będziesz lepiej przygotowany na potencjalne ataki hakerskie.",
          "title": "Rodzaje hakowania",
          "tooltip": "Uzyskaj wgląd w różne metody stosowane przez hakerów"
        },
        "uploads": {
          "text": "Ta kategoria zawiera niestandardowe filmy przesłane przez Twoją organizację.",
          "title": "Przesłane pliki",
          "tooltip": "Obejrzyj filmy przesłane przez twoją organizację, dostosowane do twoich specyficznych potrzeb w zakresie bezpieczeństwa."
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "Błąd został zgłoszony do naszego zespołu z identyfikatorem: {errorId}. Jeśli potrzebujesz natychmiastowej pomocy, skontaktuj się z naszym zespołem wsparcia pod adresem support{'@'}moxso.com.",
    "go_back": "Powrót do strony głównej",
    "text": "Wystąpił nieznany błąd i nie mogliśmy zrealizować Twojego żądania. Przepraszamy za niedogodności. Spróbuj ponownie później.",
    "title": "Coś poszło nie tak"
  },
  "forms": {
    "fields": {
      "code": "Jednorazowe hasło",
      "email": "E-mail"
    },
    "placeholders": {
      "email": "name{'@'}company.com"
    }
  },
  "loading": "Ładowanie",
  "locale": {
    "current": "Polski",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Zaloguj się",
      "next": "Następne",
      "send_one_time_code": "Wyślij kod jednorazowy",
      "try_again": "Wyślij kod ponownie"
    },
    "choose_provider": "Wybierz dostawcę",
    "loading": "Ładowanie",
    "sso": {
      "validating": "Weryfikowanie SSO"
    },
    "title": "Zaloguj się",
    "two_factor": {
      "text": "Wysłaliśmy jednorazowe hasło na twój email.",
      "title": "Sprawdź swoją skrzynkę e-mailową"
    }
  },
  "mandatory": {
    "completed": {
      "text": "Ukończyłeś polecaną zawartość, którą wybrał dla Ciebie Twój administrator.",
      "title": "Dobra robota!"
    },
    "deadline": "Termin ukończenia: {date}",
    "next_training": "Następne przypisane szkolenie",
    "policy_fallback_title": "Polityka",
    "quiz_questions": "{count} pytanie | {count} pytania | {count} pytań",
    "retake": "Podejdź ponownie",
    "start_quiz": "Rozpocznij quiz",
    "text": "Twoje przypisane szkolenie",
    "title": "Przypisane szkolenie",
    "view_policy": "Zobacz politykę"
  },
  "navigation": {
    "breaches": "Naruszenia",
    "courses": "Kursy",
    "exit": "Wyjście",
    "exit_onboarding": "Pomiń wprowadzenie",
    "login": "Zaloguj się",
    "logout": "Wyloguj się",
    "onboarding": "Onboarding",
    "onboarding_finished": "Zakończono onboarding",
    "onboarding_intro": "Wprowadzenie do onboardingu",
    "onboarding_quiz": "Quiz onboardingowy",
    "overview": "Przegląd",
    "simulation_click": "Symulacja phishingu",
    "simulations": "Symulacje",
    "videos": "Filmy"
  },
  "onboarding": {
    "finished": {
      "button": "Rozpocznij naukę",
      "subtitle": "Ukończyłeś wprowadzenie! Świetna robota, jesteś gotowy, aby rozpocząć korzystanie z Moxso. Cieszymy się, że dołączyłeś i nie możemy się doczekać, aby pomóc Ci osiągnąć Twoje cele!",
      "title": "To już wszystko!"
    },
    "intro": {
      "form": {
        "button": "Zapisz i kontynuuj",
        "help": "Wybierz język, którego chciałbyś używać podczas nauki.",
        "label": "Język nauki",
        "placeholder": "Wybierz język"
      },
      "header": {
        "description": "Witamy na twojej platformie edukacyjnej! Cieszymy się, że jesteś tutaj i jesteśmy gotowi pomóc ci osiągnąć twoje cele. Ustawmy twój profil i dostosujmy twoje doświadczenia.",
        "title": "Witamy w Moxso"
      }
    },
    "quiz": {
      "header": {
        "description": "Rozwiąż ten krótki quiz, aby pomóc nam zrozumieć Twój aktualny poziom, dzięki czemu możemy dostosować szkolenie do Twoich potrzeb.",
        "title": "Jak dobrze znasz cyberbezpieczeństwo?"
      }
    }
  },
  "overview": {
    "start_quiz": "Rozpocznij quiz",
    "welcome": "Witamy z powrotem"
  },
  "partner_text": "Platforma Moxso jest prezentowana we współpracy z {partner}.",
  "policies": {
    "cancel": {
      "text": "Ta polityka została anulowana przez administratora.",
      "title": "Anulowana polityka"
    },
    "continue": "Kontynuuj",
    "expired": {
      "text": "Ta polityka wygasła i nie jest już dostępna.",
      "title": "Wygasła polityka"
    },
    "focus": "Skupienie",
    "history": {
      "count": "{count} podpisanych",
      "show_less": "Pokaż mniej",
      "signed": "Podpisano: {date}",
      "subtitle": "Przejrzyj polityki, które już zostały przez Ciebie podpisane.",
      "title": "Podpisane polityki",
      "view_more": "Pokaż więcej"
    },
    "next": "Następne",
    "overview": "Przegląd treści",
    "policy": "Polityka",
    "quiz": {
      "confirmation_card_locked": "Musisz ukończyć quiz, aby kontynuować",
      "subtitle": "Pokaż, że znasz zasady, biorąc udział w tym quizie.",
      "subtitle_completed": "Zakończyłeś quiz. Potwierdź zapoznanie się z polityką, aby dokończyć proces.",
      "title": "Quiz",
      "title_completed": "Quiz ukończony"
    },
    "reader": "Czytelnik",
    "signature": {
      "button": "Potwierdź",
      "checkbox_label": "Zapoznałem się z polityką",
      "company": "Firma",
      "completed": {
        "button": "Zakończ",
        "policy_completed": "Zaakceptowano politykę",
        "subtitle": "Dobra robota! Zaakceptowałeś politykę.",
        "title": "Polityka zaakceptowana"
      },
      "ip_adress": "Adres IP",
      "subtitle": "Potwierdzając, oświadczasz, że zapoznałeś się z polityką i rozumiesz zasady.",
      "title": "Potwierdź zapoznanie się z polityką",
      "user_agent": "Agent użytkownika"
    },
    "this_policy_doesnt_exist_in_this_language": "Ta polityka nie jest dostępna w tym jezyku. Język wyświetlonej wersji: {locale}."
  },
  "quiz": {
    "analyze": {
      "text": "Przeanalizuj ten e-mail i uzyskaj pomoc.",
      "title": "Masz wątpilwości?"
    },
    "feedback": {
      "no": "Nie",
      "text": "Czy ta strona była pomocna?",
      "thanks": "Dziękujemy za Twoją opinię!",
      "yes": "Tak"
    },
    "help": {
      "button": "Następne pytanie",
      "text": "Przeanalizowaliśmy e-mail i znaleźliśmy następujący wynik",
      "title": "Analiza e-maili"
    },
    "intro": {
      "button": "Rozpocznij quiz",
      "text": "Przejdziemy przez 5 wiadomości e-mail w Twojej skrzynce odbiorczej Moxso. Niektóre wiadomości mogą pochodzić od oszustów próbujących uzyskać dostęp do wrażliwych danych - musisz zdecydować, czy e-mail jest próbą phishingu, czy nie. Czy jesteś gotowy?",
      "title": "Gotowy do zgłoszenia?"
    },
    "preview": "Podgląd emaila",
    "question": "Pytanie {current} z {total}",
    "result": {
      "go_back": "Wróć",
      "mails": "Mail wykryty | Maile wykryte",
      "points": "Punkty zdobyte",
      "text": {
        "bad": "Niestety, poprawnie skategoryzowałeś tylko {count} wiadomość. Ale pamiętaj: Praktyka czyni mistrza! | Niestety, poprawnie skategoryzowałeś tylko {count} wiadomości. Ale pamiętaj: Praktyka czyni mistrza!",
        "good": "Poprawnie sklasyfikowano {count} e-maili i ukończono quiz. Tak trzymaj!"
      },
      "title": {
        "bad": "Następnym razem się uda!",
        "good": "Dobra robota!"
      }
    },
    "title": "Quiz"
  },
  "resilience_score": {
    "long_text": "Wynik cyberodporności pokazuje Twoją zdolność do obrony przed cyberatakami. Wynik cyberodporności obliczany jest na podstawie Twoich wyników w quizach i symulacjach oraz zdobytych w ten sposób umiejętności. Materiały edukacyjne, takie jak filmy, pomagają Ci lepiej przygotować się do testów i symulacji.",
    "quizzing": {
      "text": "Rozwiązuj quizy jednokrotnego wyboru lepiej, aby utrwalić wiedzę i wzmocnić odporność.",
      "title": "Quizy"
    },
    "show_breakdown": "Pokaż podział",
    "simulations": {
      "text": "Bezpieczne zachowania w przypadku phishingu wzmacniają Twoją odporność. Nie klikaj w podejrzane linki i pamiętaj, aby je zgłaszać!",
      "title": "Symulacje"
    },
    "skills": {
      "text": "Utrwalaj wiedzę i rozwijaj swoje umiejętności, aby wzmocnić odporność.",
      "title": "Umiejętności"
    },
    "text": "Wynik odporności mierzy Twoją zdolność do odpierania cyberataków.",
    "title": "Wynik cyberodporności",
    "videos": {
      "text": "Filmy są ważną częścią Twojego szkolenia. Oglądaj je, aby zwiększyć swoją odporność.",
      "title": "Filmy"
    }
  },
  "search": {
    "empty": "Wpisz coś, aby rozpocząć wyszukiwanie...",
    "no_results": "Brak wyników do wyświetlenia",
    "placeholder": "Szukaj...",
    "popular": "Popularne wyszukiwania",
    "popular_terms": ["Ataki ransomware", "Inżynieria społeczna"]
  },
  "simulation": {
    "alert": {
      "text": "Ten e-mail jest częścią zautomatyzowanego ćwiczenia związanego z phishingiem, ale nie martw się, to tylko test.",
      "title": "To jest symulacja phishingowa"
    },
    "baseline": {
      "text": "Obecnie testujemy Twoich kolegów. Prosimy uprzejmie, aby nie udostępniać tej wiadomości.",
      "title": "Czy potrafisz dochować tajemnicy?"
    },
    "branding": {
      "text": "Jesteśmy tutaj, aby pomóc, więc nie wahaj się skontaktować.",
      "title": "Ćwiczenie zostało dostarczone przez Moxso."
    },
    "delivered_by": {
      "text": "To ćwiczenie zostało dostarczone przez Moxso w imieniu {companyName}. Jeśli masz jakiekolwiek pytania, skontaktuj się z {contactEmail}.",
      "title": "O tym ćwiczeniu"
    },
    "preview": "Podgląd e-maila",
    "resilience_score": {
      "text": "Twój wynik odporności określa, jak dobrze radzisz sobie z zagrożeniami cybernetycznymi.",
      "title": "Twój wynik odporności"
    },
    "submission": {
      "text": "Kliknąłeś link i trafiłeś na fałszywą, lecz przekonującą stronę internetową. W prawdziwym ataku phishingowym twoje dane uwierzytelniające mogłyby zostać wykradzione. Na szczęście, to był tylko test.",
      "title": "Co się właśnie stało?"
    },
    "training": {
      "button": "Rozpocznij swoje szkolenie"
    }
  },
  "simulations": {
    "count": "Otrzymałeś {count} symulacji od Moxso w ciągu ostatnich 90 dni.",
    "empty": {
      "text": "Nie otrzymałeś żadnych symulacji w ciągu ostatnich 90 dni.",
      "title": "Nie znaleziono symulacji"
    },
    "joined": "Dołączył do programu szkoleniowego Moxso.",
    "title": "Symulacje",
    "tooltip": {
      "click": "Kliknąłeś link w tej symulacji",
      "report": "Zgłosiłeś tę symulację",
      "submit": "Zalogowałeś się na tę symulację."
    }
  },
  "sso": {
    "login_with": "Kontynuuj z {provider}",
    "or": "lub użyj SSO",
    "redirect": "Przekazano"
  },
  "statistics": {
    "leaderboard": "Tablica wyników",
    "missing_data": {
      "text": "Musisz zdobyć punkty, aby zobaczyć swoją pozycję w rankingu.",
      "title": "Zdobądź punkty, aby zobaczyć swoją pozycję."
    },
    "points_earned": "{count} zdobytych punktów",
    "resilience_score": "Cyberodporności"
  },
  "videos": {
    "error": "Streaming jest obecnie niedostępny",
    "latest": "Najnowsze filmy",
    "more": "Zobacz więcej",
    "not_available_in_your_locale": "Ten film jest niedostępny w tym języku. Automatycznie przełączyliśmy na inny język.",
    "play": "Odtwórz wideo",
    "quiz": {
      "resume": "Wznów quiz",
      "title": "Quiz"
    },
    "related": "Powiązane filmy",
    "related_videos": "Sugerowane filmy",
    "title": "Filmy",
    "watch_again": "Obejrzyj ponownie"
  }
}
